module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C124",
    attrs: {
      "id": "id_6"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C261"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0006#page_i"
    }
  }, [_vm._v("Foreword to "), _c('em', [_vm._v("The Cullen Collection")])])]), _vm._v(" "), _c('p', {
    staticClass: "C261"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0007#page_vi"
    }
  }, [_vm._v("Introduction to "), _c('em', [_vm._v("Alec Forbes of Howglen")])])]), _vm._v(" "), _c('p', {
    staticClass: "C126"
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE")]), _vm._v(": As the introductions to the 37 volumes of "), _c('em', [_vm._v("The Cullen Collection")]), _vm._v(" form a continuous portrait of George MacDonald’s life, and as many of the introductions contain comprehensive and detailed discussion and analysis of the title in question—its plot, themes, and circumstances of writing—some first-time readers may choose to skip ahead to the story itself, saving the introduction for later, so as not to “spoil the story.”")]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0010#page_1"
    }
  }, [_vm._v("1. Burying Day")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0011#page_6"
    }
  }, [_vm._v("2. Auntie and Brownie")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0012#page_10"
    }
  }, [_vm._v("3. Final Thoughts")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part0013#page_13"
    }
  }, [_vm._v("4. A Conversation")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0014#page_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Robert Bruce")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0015#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Little Gray Town")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0016#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Robert Bruces")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0017#page_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. School")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0018#page_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. A New Friend")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0019#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. A Visit from Auntie")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0020#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Shorter Catechism")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0021#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Next Monday")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0022#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. A Visit to Howglen")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0023#page_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Alec and Thomas")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0024#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Plot")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0025#page_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Juno")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0026#page_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Revenge")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0027#page_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. A Snow Fairy")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0028#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Alec’s Boat")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0029#page_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Dowie")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0030#page_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Ballads")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0031#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Murdoch Malison")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0032#page_139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Religious Talk")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0033#page_144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Hellfire")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0034#page_148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Truffey")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0035#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Mr. Cowie Again")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0036#page_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Thomas Crann")])]), _vm._v(" "), _c('p', {
    staticClass: "C128",
    attrs: {
      "id": "id_7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0037#page_166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. The Schoolmaster’s New Friend")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0038#page_170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. The Bonnie Annie")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0039#page_179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Changes")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0040#page_183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. First Days in the City")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0041#page_190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Mr. Cupples")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0042#page_194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. A New Friend")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0043#page_202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. Alec and Mr. Cupples")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0044#page_208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Homecoming")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0045#page_213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. A New Term")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0046#page_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. Kate")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0047#page_226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. Mr. Cupples’s Warning")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0048#page_229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. Tibbie’s Cottage")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0049#page_234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. Annie and Thomas")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0050#page_240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. Arrival of the Coach")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0051#page_247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. Kate at Howglen")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0052#page_256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. Annie’s Kitten")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0053#page_263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44. Tibbie and Thomas")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0054#page_269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45. The Castle Ruin")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0055#page_275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46. The Spirit of Prophecy")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0056#page_280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47. The Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0057#page_286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48. The Stickit Minister")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0058#page_295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49. The Hypocrite")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0059#page_307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50. Kate’s Going")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0060#page_314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51. Rain")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0061#page_321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52. The Flood")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0062#page_329",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53. Rescue")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0063#page_334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54. Fall of the Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0064#page_338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55. The University Again")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0065#page_348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56. The Coming of Womanhood")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0066#page_353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57. In the Library")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0067#page_361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58. The Library in the North")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0068#page_369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59. It Comes to Blows")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0069#page_374",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60. Rumours")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0070#id_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61. The Supper")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0071#page_381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62. From Bad to Worse")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0072#page_384",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63. Evil Tidings")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0073#page_387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64. A Solemn Vow")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0074#page_393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65. End of the Session")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0075#page_396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66. Failure, Tragedy, and Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0076#page_403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67. Mr. Cupples in Glamerton")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0077#page_411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68. A Student Again")])]), _vm._v(" "), _c('p', {
    staticClass: "C128",
    attrs: {
      "id": "id_8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0078#page_415",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69. Curly and Bruce")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0079#page_423",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70. Deception Revealed")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0080#page_433",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71. The Unmasking")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0081#page_441",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72. Alec’s Plans")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0082#page_449",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73. What If…?")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0083#page_454",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74. The Bruce")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0084#page_460",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75. The Sailor’s Return")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0085#page_464",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76. Away")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0086#page_469",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77. A Meeting")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0087#page_472",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78. Annie and Alec")])]), _vm._v(" "), _c('p', {
    staticClass: "C128"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part0088#page_476",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79. Alec Forbes of Howglen")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e94be12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0004.vue
// module id = 72
// module chunks = 0